<template>
  <div>
    <Landing>
      <Login
        @ready-for-login="sendLoginRequest"
        @ready-to-get-code="getAuthCode"
        :user="user"
        :authRequired="authRequired"
        :formSubmitting1="formSubmitting1"
        :formSubmitting2="formSubmitting2"
      ></Login>
    </Landing>
  </div>
</template>
<script>
import Vue from "vue";
import config from "@/config";
import api from "@/api";
import Landing from "@/pages/others/landing";
import Login from "@/pages/auth/login/login";
import { saveCookie, getCookie, removeCookie } from "@/utils/cookies.js";
import { failureHandling } from "@/utils/errorHandling";
import rules from "@/utils/validations";
import utils from "@/utils";
import global from "@/config/index.js";
import logoutService from "@/services/bylBaseCenter/user/logout";
import loginService from "@/services/bylBaseCenter/user/login";
import {
  clearAll,
  listeningToUserActions,
} from "@/utils/listeningToUserActions";
const dispatchLogout = () => {
  removeCookie(VueApp.$vars.TOKEN_KEY);
  removeCookie(VueApp.$vars.USERID_KEY);
  removeCookie("org");
  removeCookie("query_record");
  removeCookie("ifrm_031");
  logoutService.logout().then((r) => {
    if (window.location.hostname == "localhost") {
      window.location.href = "http://localhost:8080";
    } else {
      window.location.href = "https://inesajxjy.byl.sh.cn";
    }
    // window.location.href = 'https://inesajxjy.byl.sh.cn'
  });
  // var isIP = utils.isIP(window.location.hostname);
  // if (!isIP) {
  //   // 域名/localhost的情况
  //   if (window.location.hostname == "localhost") {
  //     window.location.href = "http://localhost:8080";
  //   } else {
  //     window.location.href =
  //       "http://" + global.DEFAULT_DOMAIN + ":" + global.webport;
  //   }
  // } else {
  //   if (global.DEPLOY) {
  //     window.location.href = "http://" + window.location.hostname;
  //   } else {
  //     window.location.href =
  //       "http://" + window.location.hostname + ":" + global.webport;
  //   }
  // }
};
import { mapState, mapActions } from "vuex";
export default {
  components: { Landing, Login },
  created() {
    this.getOrgIdByCode(process.env.DEFAULT_ORGCODE).then((r) => {
      if (r) {
        let orgid = r[0].id;
        this.getModel(orgid);
      }
    });
  },
  data() {
    return {
      logo: "",
      user: null,
      authRequired: "",
      formSubmitting1: false,
      formSubmitting2: false,
    };
  },
  computed: {
    ...mapState("auth", ["isLogined"]),
  },
  methods: {
    ...mapActions("auth", {
      getCode: "getCode",
    }),
    getModel(id) {
      var that = this;
      api.post(config.bylApiPath, "/entInfo/get", { id: id }, function (r) {
        // 正常
        if (r) {
          that.logo = r.data.logo;
        }
      });
    },
    getOrgIdByCode(code) {
      return new Promise(function (resolve, reject) {
        api.post(
          config.bylApiPath,
          "/entInfo/search",
          { code: code },
          function (r) {
            // 正常
            resolve(r.data);
          }
        );
      });
    },
    sendLoginRequest(data) {
      var type = data[0];
      var user = data[1];
      if (user.checked === true) {
        // 判断复选框是否被勾选 勾选则调用配置cookie方法
        var p = {
          phone: user.accountName,
          password: user.password,
        };
        saveCookie("rme_fresh", p); // 保存记住我状态
      } else {
        removeCookie("rme_fresh");
      }
      if (type === "1") {
        // 用户名密码登录
        this.localLogin(this.createLocalLoginModel(user));
      } else if (type === "2") {
        // 验证码登录
        this.codeLogin(this.createCodeLoginModel(user));
      }
    },
    getAuthCode(phone) {
      if (phone && phone !== (null || undefined || "")) {
        this.getCode(phone);
      }
    },
    getType(str) {
      var type = null;
      if (rules.cellphone.pattern.test(str)) {
        type = "2";
      } else if (rules.email.pattern.test(str)) {
        type = "3";
      } else {
        type = "1";
      }
      return type;
    },
    createLocalLoginModel(o) {
      let obj = {};
      obj.accountName = o.accountName;
      obj.password = o.password;
      obj.verify = o.verify;
      obj.type = this.getType(o.accountName);
      obj.loginType = "2";
      return obj;
    },
    createCodeLoginModel(o) {
      let obj = {};
      obj.phone = o.phone;
      obj.verify = o.code;
      obj.loginType = "2";
      return obj;
    },
    localLogin(val) {
      // 正常登录
      this.formSubmitting1 = true; // 让页面上的提交按钮消失
      loginService.localLogin(val).then(
        (r) => {
          if (r.message === "USER_ERROR_00030") {
            Vue.toasted.show("你的密码需同时含数字、字母和特殊字符");
          } else {
            Vue.toasted.show("登录成功");
          }
          listeningToUserActions(dispatchLogout);
          this.formSubmitting1 = false;
          saveCookie(this.$vars.TOKEN_KEY, r.data.token);
          saveCookie(this.$vars.USERID_KEY, r.data.user.id);
          this.$router.push({ path: "/" });
        },
        (err) => {
          this.formSubmitting1 = false;
          if (err == "USER_ERROR_00002" || err == "USER_ERROR_00003") {
            // 验证码错误
            failureHandling(err);
            loginService.getPicCode().then((r) => {
              this.authRequired = r.data;
            });
          } else {
            failureHandling(err);
          }
        }
      );
    },
    codeLogin(val) {
      this.formSubmitting2 = true; // 让页面上的提交按钮消失
      loginService.codeLogin(val).then(
        (r) => {
          listeningToUserActions(dispatchLogout);
          this.formSubmitting2 = false;
          saveCookie(this.$vars.TOKEN_KEY, r.data.token);
          saveCookie(this.$vars.USERID_KEY, r.data.user.id);
          this.$router.push({ path: "/" });
        },
        (err) => {
          this.formSubmitting2 = false;
          failureHandling(err);
        }
      );
    },
  },
};
</script>
<style scoped>
@import "assets/login.css";
</style>




// WEBPACK FOOTER //
// src/pages/auth/pageLogin.vue